import { h, defineComponent, VNode } from 'vue';
import { t } from '@/ui/i18n/i18n';
import { box, container, pageTitle } from '@/ui/components';

/**
 * used to test quickly some components
 */
export const TestPage = defineComponent({
  name: 'TestPage',
  setup() {
    return function render(): VNode {
      return container([
        pageTitle(t('test page')),
        box([
          h('div', { class: 'columns has-text-centered' }, [
            'TEST!',
            //add something
          ]),
        ]),
      ]);
    };
  },
});
